import axios from "axios";

const state = () => ({
    readings: [],
    generated_bills: [],
    generates: [],
    rows: 1,
    perPage: 10,
    meta: {},
    generatesMeta: {},
    errorLogs: [],
    errorLog: {},
});

const getters = {
    readings: (state) => {
        return state.readings;
    },
    generated_bills: (state) => {
        return state.generated_bills;
    },
    generates: (state) => {
        return state.generates;
    },
    generatesMeta: (state) => {
        return state.generatesMeta;
    },
    rows: (state) => {
        return state.rows;
    },
    perPage: (state) => {
        return state.perPage;
    },
    meta: state => {
        return state.meta;
    },
    errorLogs: (state) => {
        return state.errorLogs;
    },
    errorLog: (state) => {
        return state.errorLog;
    },
};

// actions
const actions = {
    getReadings({commit, dispatch}, params) {
        const queryParams = new URLSearchParams(params);

        const queryString = queryParams.toString();
        dispatch("Settings/loading", true, {root: true});
        try {
            axios.get(`/admin/readings?${queryString}`).then((responseData) => {
                dispatch("Settings/loading", false, {root: true});
                if (!responseData.data.status){
                    commit("SET_READINGS", []);
                    commit('SET_META', {})
                    return;
                }
                const {
                    data,
                    links,
                    first_page_url,
                    last_page_url,
                    next_page_url,
                    prev_page_url,
                    path,
                    ...meta
                } = responseData.data.data;
                commit("SET_READINGS", data);
                commit('SET_META', meta)
                dispatch("Settings/loading", false, {root: true});
            }).catch((err) => {
                console.log(err);
                dispatch("Settings/loading", false, {root: true});
            });
        } catch (err) {
            console.log(err);
            dispatch("Settings/loading", false, {root: true});
        }
    },
    getGeneratedBills({commit, dispatch}, params) {
        const queryParams = new URLSearchParams(params);

        const queryString = queryParams.toString();
        dispatch("Settings/loading", true, {root: true});
        try {
            axios.get(`/admin/bill-generates?${queryString}`).then((responseData) => {
                dispatch("Settings/loading", false, {root: true});
                if (!responseData.data.status){
                    commit("SET_GENERATED_BILLS", []);
                    commit('SET_META', {})
                    return;
                }
                const {
                    data,
                    links,
                    first_page_url,
                    last_page_url,
                    next_page_url,
                    prev_page_url,
                    path,
                    ...meta
                } = responseData.data.data;
                commit("SET_GENERATED_BILLS", data);
                commit('SET_META', meta)
                dispatch("Settings/loading", false, {root: true});
            }).catch((err) => {
                console.log(err);
                dispatch("Settings/loading", false, {root: true});
            });
        } catch (err) {
            console.log(err);
            dispatch("Settings/loading", false, {root: true});
        }
    },
    getGenerates({commit, dispatch}, params) {
        dispatch("Settings/loading", true, {root: true});
        return axios.get('/admin/generates', {params})
            .then((res) => {
                commit("SET_GENERATES", res.data.data.data);
                commit("SET_GENERATES_META", res.data.data);
                dispatch("Settings/loading", false, {root: true});
            })
            .catch((err) => {
                console.log(err);
                dispatch("Settings/loading", false, {root: true});
            });
    },

    deleteGenerate({commit, dispatch}, id) {
        dispatch("Settings/loading", true, {root: true});
        return axios.delete(`/admin/generates/${id}`)
            .then((res) => {
                commit("REMOVE_GENERATE", id);
                dispatch("Settings/loading", false, {root: true});
                return res;
            })
            .catch((err) => {
                dispatch("Settings/loading", false, {root: true});
                throw err;
            });
    },

    getGenerateDetails({dispatch}, {id, type}) {
        dispatch("Settings/loading", true, {root: true});
        const endpoint = type === 'bill'
            ? `/admin/generates/${id}/bill-details`
            : `/admin/generates/${id}/reading-details`;
        return axios.get(endpoint)
            .then((res) => {
                dispatch("Settings/loading", false, {root: true});
                return res.data;
            })
            .catch((err) => {
                dispatch("Settings/loading", false, {root: true});
                throw err;
            });
    },

    store({commit, dispatch}, params) {
        dispatch("Settings/loading", true, {root: true});
        try {
            axios.post(`/admin/readings`, params).then((res) => {
                dispatch("Settings/loading", false, {root: true});
                return res;
            }).catch((err) => {
                console.log(err);
                dispatch("Settings/loading", false, {root: true});
            });
        } catch (err) {
            console.log(err);
            dispatch("Settings/loading", false, {root: true});
        }
    },
};

// mutations
const mutations = {
    SET_READINGS(state, readings) {
        state.readings = readings;
    },
    SET_GENERATED_BILLS(state, generated_bills) {
        state.generated_bills = generated_bills;
    },
    SET_GENERATES(state, generates) {
        state.generates = generates;
    },
    SET_GENERATES_META(state, meta) {
        state.generatesMeta = {
            current_page: meta.current_page,
            per_page:     meta.per_page,
            total:        meta.total,
            last_page:    meta.last_page,
            from:         meta.from,
        };
    },
    REMOVE_GENERATE(state, id) {
        state.generates = state.generates.filter(g => Number(g.id) !== Number(id));
        if (state.generatesMeta.total) state.generatesMeta.total--;
    },
    setRows(state, rows) {
        state.rows = rows;
    },
    setPerPage(state, perPage) {
        state.perPage = perPage;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    setErrorLogs(state, errorLogs) {
        state.errorLogs = errorLogs;
    },
    setErrorLog(state, errorLog) {
        state.errorLog = errorLog;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
